import React from 'react';
import {Container, Typography, Grid, Card, CardContent, Box, List, ListItem, ListItemIcon, Button} from '@mui/material';
import {CheckCircleOutline} from "@mui/icons-material";
import {WithTranslation, withTranslation} from "react-i18next";

interface OfferProps extends WithTranslation {}

class Offer extends React.Component<OfferProps> {
    state = {
        showScrollTopArrow: false
    };

    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    componentDidMount(): void {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount(): void {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll = (): void => {
        if (window.scrollY > 300) {
            this.setState({ showScrollTopArrow: true });
        } else {
            this.setState({ showScrollTopArrow: false });
        }
    }

    private scrollToTop = (): void => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    private scrollToComponent = (componentId: string): void => {
        const element = document.getElementById(componentId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    render(): JSX.Element {
        const { t } = this.props;
        const services = [
            {
                title: t('services.webServices.title'),
                description: t('services.webServices.description'),
                features: [
                    t('services.webServices.features.customSolutions'),
                    t('services.webServices.features.highQualityCode'),
                    t('services.webServices.features.userCenteredDesign'),
                    t('services.webServices.features.supportAndMaintenance'),
                    t('services.webServices.features.security'),
                    t('services.webServices.features.integration'),
                ],
            },
            {
                title: t('services.eCommerce.title'),
                description: t('services.eCommerce.description'),
                features: [
                    t('services.eCommerce.features.userFriendlyDesign'),
                    t('services.eCommerce.features.mobileOptimization'),
                    t('services.eCommerce.features.securePaymentGateways'),
                    t('services.eCommerce.features.inventoryManagement'),
                    t('services.eCommerce.features.seoOptimization'),
                    t('services.eCommerce.features.customerSupport'),
                ],
            },
            {
                title: t('services.cooperation.title'),
                description: t('services.cooperation.description'),
                features: [
                    t('services.cooperation.features.openCollaboration'),
                    t('services.cooperation.features.skilledTeam'),
                    t('services.cooperation.features.qualityWork'),
                    t('services.cooperation.features.reliability'),
                    t('services.cooperation.features.flexibility'),
                    t('services.cooperation.features.communication'),
                ],
            },
        ];
        return (
            <Box style={{ padding: '60px 0', backgroundColor: "#fff" }} id="offer">
                <Container style={{ padding: '60px 0' }}>
                    <Typography variant="h3" gutterBottom style={{ fontWeight: 'bold', color: '#0A74DA', textAlign: 'center' }}>
                        {t('offer')}
                    </Typography>
                    <Grid container spacing={4}>
                        {services.map((service, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card style={{ height: '100%', boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)' }}>
                                    <CardContent>
                                        <Typography variant="h5" gutterBottom style={{ color: '#0A74DA' }}>
                                            {service.title}
                                        </Typography>
                                        <Typography paragraph>
                                            {service.description}
                                        </Typography>
                                        {service.features && (
                                            <List dense>
                                                {service.features.map((feature, index: number) => (
                                                    <ListItem key={index}>
                                                        <ListItemIcon>
                                                            <CheckCircleOutline style={{ color: '#0A74DA' }} />
                                                        </ListItemIcon>
                                                        <Typography variant="body2">{feature}</Typography>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        )}
                                        <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                            <Button variant="outlined" color="secondary" onClick={() => this.scrollToComponent('contact')} style={{ alignSelf: 'center' }}>
                                                {t('contact')}
                                            </Button>
                                        </CardContent>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        );
    };
}
export default withTranslation()(Offer);
